export default __webpack_public_path__ + "static/media/incr.464e5a14.png";